<?xml version="1.0" encoding="UTF-8"?>
<svg fill="none" viewBox="0 0 7 13" xmlns="http://www.w3.org/2000/svg">
<path d="m0.75 11.75 5.25-5.25-5.25-5.25" stroke="#2D2D2D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" class="strokeDefault"/>
</svg>
